module.exports = __webpack_public_path__ + "static/BigID-47f51328e70b12b1187e7b80c81af583.jpg";